/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

import ErrorName from '../../error/error-name';

/**
 * Správce fyzických senzorů pro standardní webové technologie.
 * @implements {SensorManager}
 */
class WebSensorManager {
  /** @inheritdoc */
  getTemperature() {
    return new Promise(() => {
      const error = new Error('Unable to get the temperature.');
      error.name = ErrorName.NotSupportedError;
      throw error;
    });
  }
}

export default WebSensorManager;
